import React from 'react';
import Avatar from '../../components/Avatar';
import SVGIcon from '../../components/SVGIcon';
import type { SelectEntityOptionProps } from '../../components/SelectEntityOption';
import SelectEntityOption from '../../components/SelectEntityOption';
import addIcon from '../../icons/non-prefilled/16x16/add.svg';
import styles from './NewSelectOption.module.scss';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const AVATAR_FRAGMENT = gql(`
  fragment NewSelectOption_avatar on Image {
    thumb
    original
  }
`);

export interface NewSelectOptionProps extends SelectEntityOptionProps {
  id?: string;
  label: React.ReactNode;
  secondary?: React.ReactNode;
  name: string;
  avatar?: DocumentType<typeof AVATAR_FRAGMENT> | null;
}

const NewSelectOption = (props: NewSelectOptionProps) => {
  return (
    <SelectEntityOption
      icon={
        props.name && props.avatar ? (
          <Avatar
            user={{
              id: props.id ?? 'new',
              name: props.name,
              avatar: props.avatar,
            }}
          />
        ) : (
          <div className={styles.newIconContainer}>
            <SVGIcon>{addIcon}</SVGIcon>
          </div>
        )
      }
      {...props}
    />
  );
};

export default NewSelectOption;
